import React, { useState } from 'react';
import BenchmarkIndexes from './BenchmarkIndexes';
import PaperInstruments from './PaperInstruments';

const VIEWS = [
    { value: 'benchmarks', label: 'Benchmark indexes' },
    { value: 'instruments', label: 'Swap & futures instruments' },
];

/**
 * Benchmarks & Instruments (ledger row 132, AC1-AC5): the prices the company
 * prices deals against, and the swaps and futures the desk hedges with. Every
 * instrument settles off one benchmark, so the two lists live side by side.
 */
const BenchmarksTab = () => {
    const [view, setView] = useState('benchmarks');

    return (
        <div className="pp-panel">
            <div className="pp-subtabs" role="tablist" aria-label="Benchmarks and instruments">
                {VIEWS.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        role="tab"
                        aria-selected={view === option.value}
                        className={`pp-subtab ${view === option.value ? 'pp-subtab--active' : ''}`}
                        onClick={() => setView(option.value)}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
            {view === 'benchmarks' ? <BenchmarkIndexes /> : <PaperInstruments />}
        </div>
    );
};

export default BenchmarksTab;
